import { CaptionContainer } from "@piperunner-cms/component/RTERenderer/common";
import type { NodeProps } from "@tiptap/static-renderer/json/react";
import { CodeStack, type LiveCodeBlockAttributes } from "../type";
import { JavaScriptSandbox } from "./JavaScriptSandbox";

function LiveCodeBlockNodeView({ node }: NodeProps) {
  const { caption, codeStack, data } = node.attrs as LiveCodeBlockAttributes;

  return (
    <CaptionContainer caption={caption}>
      {codeStack === CodeStack.JAVASCRIPT && <JavaScriptSandbox data={data} />}
    </CaptionContainer>
  );
}

export default LiveCodeBlockNodeView;
